import React from 'react';
import { ICreateInitial, IReactDOMAdapter } from './type';

export const CreateInitial = (
    Component: React.ComponentType<any>,
    adapter: IReactDOMAdapter
): ICreateInitial => {
    const reactDomAdapter = adapter;

    let root: any = null;
    let container: Element | null = null;

    return {
        _root: null,
        mount: function (selector: string) {
            container = document.querySelector(selector);
            if (!container) throw new Error('Mount target not found');
            root = reactDomAdapter.render(<Component />, container);
            this._root = root;
        },
        unmount: function () {
            if (container) reactDomAdapter.unmount(container, root);
            this._root = null;
        }
    };
};

